// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-bce699da] {\n  width: 170px !important;\n}\n.title-resume[data-v-bce699da] {\n  color:#3c3cfa;\n}\n", ""]);
// Exports
module.exports = exports;
